module.exports = __webpack_public_path__ + "public/img/youhuiquan.92eb8269.png";